import Icon from 'components/shared/Icon/Icon';

import './assets/spin.scss';

const ProcessingFilesPlaceholder = () => {
  return (
    <div className="items-top flex w-full justify-center">
      <div className="mt-28 flex flex-col items-center gap-4 text-center">
        <Icon icon="file-processing" />
        <div className="flex max-w-[500px] flex-col gap-4">
          <p className="text-lg font-semibold text-primary-900">Processing Your Files</p>
          <p className="text-sm text-neutral-500">
            Continue with the rest of the steps while your data is being processed. You will be
            notified when the import is complete.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProcessingFilesPlaceholder;
